__turbopack_context__.v({
  "btn": "nqn5Bq_btn",
  "control": "nqn5Bq_control",
  "description": "nqn5Bq_description",
  "left": "nqn5Bq_left",
  "mobileDescWrapper": "nqn5Bq_mobileDescWrapper",
  "mobileDetails": "nqn5Bq_mobileDetails",
  "primary": "nqn5Bq_primary",
  "right": "nqn5Bq_right",
  "root": "nqn5Bq_root",
  "title": "nqn5Bq_title",
});
